export default __webpack_public_path__ + "static/media/Insta.51dba6d8.svg";